import { InstallButton } from "./InstallButton";
import { LEVELS } from "../game/maze";
import { STRINGS, useT } from "../i18n";
import { AccountBar } from "./AccountBar";
import { formatTime } from "../lib/api";

export const LangSwitch = ({ lang, setLang }) => (
  <div className="lang-switch" role="radiogroup" aria-label="Lingua / Language">
    {Object.keys(STRINGS).map((l) => (
      <button
        type="button"
        key={l}
        role="radio"
        aria-checked={lang === l}
        className={`lang-opt ${lang === l ? "active" : ""}`}
        onClick={() => setLang(l)}
        data-testid={`lang-${l}`}
      >
        {l.toUpperCase()}
      </button>
    ))}
  </div>
);

export const LevelPicker = ({ value, onChange, testPrefix = "level" }) => {
  const t = useT();
  return (
  <div className="level-picker" role="radiogroup">
    {Object.keys(LEVELS).map((key) => (
      <button
        type="button"
        key={key}
        role="radio"
        aria-checked={value === key}
        className={`level-opt level-${key} ${value === key ? "active" : ""}`}
        onClick={() => onChange(key)}
        data-testid={`${testPrefix}-${key}`}
      >
        <span className="level-name">{t.levels[key]}</span>
      </button>
    ))}
  </div>
  );
};

export const StartScreen = ({ name, setName, level, setLevel, lang, setLang, user, onLogout, onDelete, notice, onStart, onBoard }) => {
  const t = useT();
  const submit = (e) => {
    e.preventDefault();
    if (name.trim()) onStart();
  };
  return (
    <div className="overlay" data-testid="start-screen-container">
      <form className="panel panel-enter" onSubmit={submit}>
        <div className="panel-top">
          <p className="eyebrow">{t.eyebrow}</p>
          <LangSwitch lang={lang} setLang={setLang} />
        </div>
        <h1 className="title">{t.title}</h1>
        {notice && (
          <p className="notice" data-testid="pending-saved-notice">
            {t.savedPending} · {t.levels[notice.level]} · {formatTime(notice.time)} · #{notice.rank}
          </p>
        )}
        <AccountBar user={user} onLogout={onLogout} onDelete={onDelete} />
        <label className="field-label" htmlFor="player-name">{t.playerName}</label>
        <input
          id="player-name"
          className="field"
          value={name}
          maxLength={20}
          autoFocus
          placeholder={t.namePlaceholder}
          onChange={(e) => setName(e.target.value)}
          data-testid="player-name-input"
        />
        <span className="field-label">{t.difficulty}</span>
        <LevelPicker value={level} onChange={setLevel} />
        <div className="row">
          <button type="submit" className="btn-primary" disabled={!name.trim()} data-testid="start-game-button">
            {t.enter}
          </button>
          <button type="button" className="btn-ghost" onClick={onBoard} data-testid="start-leaderboard-button">
            {t.leaderboard}
          </button>
          <InstallButton />
        </div>
        <Controls />
        <div className="legal-links">
          <a className="privacy-link" href="/privacy.html" target="_blank" rel="noreferrer" data-testid="start-privacy-link">{t.privacy}</a>
        </div>
      </form>
    </div>
  );
};

export const Controls = () => {
  const c = useT().controls;
  return (
    <ul className="controls" data-testid="controls-hint">
      <li><kbd>A</kbd><kbd>D</kbd> / <kbd>&larr;</kbd><kbd>&rarr;</kbd> {c.move}</li>
      <li><kbd>{c.space}</kbd> {c.jump}</li>
      <li><kbd>W</kbd> / <kbd>&uarr;</kbd> {c.enter}</li>
      <li><kbd>S</kbd> / <kbd>&darr;</kbd> {c.down}</li>
      <li><kbd>E</kbd> {c.chalk}</li>
      <li><kbd>Esc</kbd> {c.pause}</li>
    </ul>
  );
};
